module.exports = __webpack_public_path__ + "img/tooltip_09-vallone-aure-wood-thermo-oak-milled.cdcc7354.jpg";